import { render, staticRenderFns } from "./ClinicalAssistantPanel.vue?vue&type=template&id=42898327&scoped=true"
import script from "./ClinicalAssistantPanel.vue?vue&type=script&lang=js"
export * from "./ClinicalAssistantPanel.vue?vue&type=script&lang=js"
import style0 from "./ClinicalAssistantPanel.vue?vue&type=style&index=0&id=42898327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42898327",
  null
  
)

export default component.exports